import CommManagerInterface from "@/hosted_fields/master/interface";

export default interface PluginInterface {
  config: PluginConfig;
  init(): Promise<void>;
}

export enum PluginName {
  COMPONENTS_FIELDS = 'COMPONENTS_FIELDS',
  LOGGER = 'LOGGER',
  THREE_DOMAIN_SECURE = 'THREE_DOMAIN_SECURE',
  CHECKOUT_UTILS = 'CHECKOUT_UTILS',
  FUNCTIONS = 'FUNCTIONS',
  IDEAL = 'IDEAL',
  SOFORT = 'SOFORT',
  BANCONTACT = 'BANCONTACT',
  GOOGLE_PAY = 'GOOGLE_PAY',
  GIROPAY = 'GIROPAY',
  DOTPAY = 'DOTPAY',
  PAYPAL = 'PAYPAL',
  NETBANKING = 'NETBANKING',
  DIRECT_DEBIT = 'DIRECT_DEBIT',
  APPLE_PAY = 'APPLE_PAY'
}

export type PluginConfig = {
  site: string,
  hostname: string,
  publishableKey: string,
}